import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { formatDate, getPlainText } from '../utils/Helpers';
import Description from 'pages/projects/kanban/Milestone/Description/Description';
import { useSocket } from 'pages/projects/kanban/context/SocketContext';
import DeleteModal from './DeleteModal';

const InstructionsModal = ({ show, onHide, channelDetails, projectBoardId }) => {
  const socket = useSocket();

  const [instruction, setInstruction] = useState('');
  const [showTextEditor, setShowTextEditor] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [hasInstruction, setHasInstruction] = useState(false);

  useEffect(() => {
    if (channelDetails) {
      setInstruction(channelDetails.instruction);
      let plaintext = getPlainText(channelDetails?.instruction);

      if (plaintext.length > 0) {
        setHasInstruction(true);
      } else {
        setHasInstruction(false);
      }
    } else {
      setInstruction('');
    }
  }, [channelDetails]);

  const handleDeleteInstruction = async () => {
    if (!channelDetails) return;

    try {
      setDeleteLoading(true);

      // Optimistic UI
      setInstruction('');
      setShowTextEditor(false);

      socket.emit('update-channel', {
        id: channelDetails._id,
        payload: { instruction: '' },
        projectBoardId
      });

      setShowDeleteModal(false);
      onHide();
    } catch (err) {
      console.error('Delete instruction error:', err);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleSubmitInstruction = (value) => {
    // 1️⃣ Optimistic UI update
    setInstruction(value);
    setShowTextEditor(false);

    // 2️⃣ Socket emit
    if (channelDetails) {
      socket.emit('update-channel', {
        id: channelDetails?._id,
        payload: { instruction: value },
        projectBoardId
      });
    }
  };

  // Optional: reset editor when modal closes
  useEffect(() => {
    if (!show) {
      setShowDeleteModal(false);
      setDeleteLoading(false);
      setShowTextEditor(false);
    }
  }, [show]);

  return (
    <>
      <Modal show={show} onHide={onHide} centered className="modal-instruction">
        <Modal.Header closeButton>
          <div className="header-top-content">
            <div className="header-left-text">
              <p>
                Happy Ending / Kanban / <span>Instructions</span>
              </p>
            </div>

            <div className="header-right-text">
              {channelDetails && <p>Created on {formatDate(channelDetails?.createdDate || new Date())}</p>}
              {hasInstruction && (
                <>
                  <span>&nbsp;</span>
                  <button className="disabled-Delete" onClick={() => setShowDeleteModal(true)}>
                    Delete
                  </button>
                </>
              )}
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="instructions-body">
            <label>{channelDetails?.name}</label>

            <Description
              isInstruction={true}
              description={getPlainText(instruction) ? instruction : ''}
              showTextEditor={showTextEditor}
              setShowTextEditor={setShowTextEditor}
              handleSubmitDescription={handleSubmitInstruction}
              viewMode={false}
              isDesc={true}
            />
          </div>
        </Modal.Body>
      </Modal>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        handleDelete={handleDeleteInstruction}
        loading={deleteLoading}
        itemName="instructions"
      />
    </>
  );
};

export default InstructionsModal;
